(function () {
    "use strict";

    angular.module("app").directive("syncFormValidity", SyncFormValidityDirective);

    SyncFormValidityDirective.$inject = ["actionbarService", "HABIL_EVENTS",];
    function SyncFormValidityDirective(actionbarService, HABIL_EVENTS) {
        return {
            require: { ngFormCtrl: "^form" },
            link: function (scope, _element, _attrs, ctrl) {
                const ngForm = ctrl.ngFormCtrl;

                scope.$watch(function () {
                    return ngForm.$valid;
                }, function (isValid) {
                    actionbarService.Broadcast(HABIL_EVENTS.actionBar.isAllowed, isValid);
                });
            }
        };
    }
})();
